
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/result.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-weet-result-demo-success","docs-weet-result-demo-info","docs-weet-result-demo-error","docs-weet-result-demo-warning","docs-weet-result-demo-500","docs-weet-result-demo-403","docs-weet-result-demo-404"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/result.md?type=demo')
};